import { useMemo } from 'react'
import { getStripe } from '@/lib/stripe'

export const useStripeElements = () => {
  return useMemo(() => getStripe(), [])
}
